import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AppStore } from '@app/core/store/app.store';
import { DialogService } from '@siu/shared';
//import { IUser } from "src/app/shared/src/lib/interfaces/user.interface";
import { Router } from "@angular/router";

@Component({
  selector: 'app-aviso-usuario',
  templateUrl: './aviso-usuario.component.html',
  styleUrls: ['./aviso-usuario.component.css']
})
export class AvisoUsuarioComponent implements OnInit, OnDestroy {
  //@Input() user: IUser;
  @Output("on-logout") onLogoutEvent: EventEmitter<any> =new EventEmitter<any>();
  ocultarSubmit: boolean = false;
  tituloModal: string = "Aviso Publico";
  showGuia : boolean = true;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<AvisoUsuarioComponent>,
    public dialog: DialogService,
    private appStore: AppStore
  ) { }

  ngOnInit() {
  }
  handleClose = () => {

    //alert("clic");
    //let tipo = this.user.ttipoUsuario
    localStorage.setItem('avisoAceptado', '0');
    //this.appStore.sessionAction.logout();
    this.router.navigate(["/home"]);
    this.dialogRef.close();
    // if(tipo == 1){
    //   location.href = environment.loginOut + location.origin + this.router.routerState.snapshot.url;
    // }
    // else{
       //location.href = environment.loginOutSIGO + location.origin + this.router.routerState.snapshot.url;
    // }

    //this.onLogoutEvent.emit();

};
handleConfirmar = () => {
  localStorage.setItem('avisoAceptado', '1');
  this.dialogRef.close();

};


  ngOnDestroy(){
  }

}
